import formatItem from '../../../../../../../shared/formatItem';

/**
 *
 * @param {*} notification
 * @returns {{
 *  eventType: string,
 *  showEncourageSellerReply: boolean,
 *  sender: {
 *      username: string,
 *      profilePictureUrl: string?
 *  },
 *  sentAt: number,
 *  conversationUrl: string?
 * }} message
 */
export const parseNotification = (notification) => {
    const { url, profilePictureUrl, username, eventType, showEncourageSellerReply } = formatItem(notification);

    return {
        showEncourageSellerReply,
        eventType,
        conversationUrl: url,
        sender: {
            username,
            profilePictureUrl,
        },
        sentAt: Date.now(),
    };
};
